<template >
  <div v-if="ready" >
    <div v-if="viewMode" >
      {{ parsedLabel(cvalue) }}
      <!-- <el-tag v-for="(opt,idx) in selectedOptions" :key="idx">{{parsedLabel(opt)}}</el-tag> -->
    </div >
    <q-select
        v-else
        class="general-select"
        xfilled
        v-model="cvalue"
        use-input
        clearable
        :multiple="multiple"
        dense
        hide-dropdown-icon
        :stack-label="false"
        xhide-selected
        :option-value="valueProp"
        hide-bottom-space
        :option-label="labelProp"
        input-debounce="0"
        :label="placeholder"
        menu-shrink
        options-dense
        :options="selectOptions"
        @filter="filterFn"
        :style="(fit?'':'min-width: 250px;')+'width: 100%'"
        xbehavior="menu" >
      <template v-slot:no-option >
        <q-item >
          <q-item-section class="text-grey" >No results</q-item-section >
        </q-item >
      </template >
    </q-select >
    <!-- <el-select
      style="width:100%"
      :class="(large)?'largefit':''"
      :placeholder="placeholder"
      v-else
      v-model="cvalue"
      ref="sselector"
      :allow-create="allowCreate"
      :filterable="filterable"
      :clearable="clearable"
      :multiple="multiple"
      @change="refocus"
    >
      <el-option
        v-for="item in selectOptions"
        :key="item[valueProp]"
        :label="item[labelProp]"
        :value="item[valueProp]"
        v-html="parsedLabel(item)"
      ></el-option>
    </el-select>-->
  </div >
</template >

<script >
import {mapActions, mapGetters} from "vuex";
import _ from "lodash";

export default {
  name: "s-general-select",
  data() {
    return {
      cvalue: null,
      selectOptions: null,
      ready: false,
      stmpValue: null,
      stringOptions: null
    };
  },
  props: {
    fit: {type: Boolean, default: true},
    large: {type: Boolean, default: false},
    viewMode: {type: Boolean, default: false},
    optionsParser: {type: Function, default: null},
    simpleOptions: {type: Boolean, default: false},
    objectValues: {type: Boolean, default: false},
    stringfy: {type: Boolean, default: false},
    focusthis: {default: false},
    filterable: {default: true},
    clearable: {default: true},
    multiple: {default: false},
    allowCreate: {type: Boolean, default: false},
    // ref: { default: null },
    options: {default: null},
    value: {default: null},
    keField: {type: String, default: "id"},
    classModel: {type: String, default: null},
    placeholder: {type: String, default: "..."},
    labelProp: {default: "label"},
    valueProp: {default: "id"}
  },
  watch: {
    value: {
      handler(v, vo) {
        this.prepareSelectOptions();
        // this.cvalue = this.value;
        _log_("setting value,", v);
        // return;

        let stmp = null, contraStmp
        if (!this.objectValues) {
          //todo handle multiple

          stmp = v && _.isObject(v) ? v[this.valueProp] : v;
        }
        else
          stmp = v && v != "" ? JSON.stringify(v) : null;
        // if (!this.objectValues) {
        //   //todo handle multiple
        //
        //   contraStmp = this.cvalue && _.isObject(this.cvalue) ? this.cvalue[this.valueProp] : this.cvalue;
        // }
        // else
        //   contraStmp = this.cvalue && this.cvalue != "" ? JSON.stringify(this.cvalue) : null;
        //
        // contraStmp = contraStmp ? contraStmp : null
        //
        // stmp = stmp ? stmp : null
        // _log_("setting value,", contraStmp, stmp);
        // if (stmp == contraStmp) return;
        if (stmp == this.stmpValue) return;
        this.stmpValue = stmp;
        if (this.simpleOptions) {
          this.cvalue = v;
          return;
        }
        const vm = this;

        if (!v) {
          this.cvalue = null;
          return;
        }
        if (this.multiple) {
          if (_.isString(v)) v = v.split(",");
          if (!this.simpleOptions && this.objectValues)
            v.map(x => {
              x[vm.valueProp] = "" + x[vm.valueProp];
            });
          if (v && !v.length) v = null;
        }
        else v = v ? "" + v : null;
        if (v && !_.isObject(v)) {
          let q = {};
          q[this.valueProp] = v;
          v = this.findInArray(vm.stringOptions, q);
        }

        this.cvalue = v;
      },
      deep: true,
      immediate: true
    },
    cvalue: function (val, oldval) {

      if (this.multiple && val && !val.length) val = null;


      let stmp = null
      if (!this.objectValues && !this.multiple) {
        //todo handle multiple

        val = val && _.isObject(val) ? val[this.valueProp] : val;
        stmp = val
      }
      else
        stmp = val && val != "" ? JSON.stringify(val) : null;
      _log_("setting Cvalue,", this.stmpValue, stmp);
      if (stmp == this.stmpValue) return;
      this.stmpValue = stmp;
      if (this.multiple && this.stringfy) val = val.join(",");

      this.$emit("input", val);
      this.$emit("change", {val: val, oldval: oldval});
    }
  },
  computed: {
    ...mapGetters({
      getList: "tags/getList"
    }),
    selectedOptions() {
      _log_("change val,", this.cvalue);
      if (this.simpleOptions) return this.cvalue;
      if (!this.cvalue || this.cvalue == "" || !this.cvalue.length) return;
      const so = !_.isArray(this.cvalue) ? [this.cvalue] : this.cvalue;
      return so;
      const vm = this;
      // _log_("change val,", so, vm.valueProp);
      return this.options?.filter(x => so.indexOf(x[vm.valueProp]) >= 0);
    }
  },

  methods: {
    prepareSelectOptions() {
      if (this.simpleOptions) {
        this.stringOptions = this.options;
        return;
      }
      const vm = this;
      this.stringOptions = this.options?.map(x => {
        x[vm.valueProp] = "" + x[vm.valueProp];
        return x;
      });
      // _log_("set stringOptions val,", this.stringOptions);
    },
    filterFn(val, update) {
      const vm = this,
          serchF = this.labelProp ? this.labelProp : this.valueProp;
      _log_("change stringOptions val,", this.stringOptions);
      if (val === "") {
        update(() => {
          vm.selectOptions = vm.stringOptions;
        });
        return;
      }

      update(() => {
        const needle = _.isString(val) ? val.toLowerCase() : val;
        vm.selectOptions = vm.stringOptions.filter(
            v => (v[serchF]+"").toLowerCase()
                          .indexOf(needle) > -1
        );
      });
    },
    ...mapActions({
      fetch: "tags/fetch",
      fetchAllOptions: "tags/fetchAll"
    }),
    parsedLabel(item) {
      if (!item) return "";
      if (this.optionsParser) return this.optionsParser(item);
      if (this.simpleOptions) return item;
      return item[this.labelProp];
    },
    refocus() {
      var vm = this;

      let elel = this.$el; // vm.$refs['sselector']
      // if (elel) elel[0].focus()
      // _log_("change sel.", elel);
      //  elel.focus();
      let inputs = elel.getElementsByTagName("input");
      // let elel = vm.$refs['col_input' + rowScope.column.property]
      // // if (elel) elel[0].focus()
      // _log_('is ins..F.' + colIndex, elel[0])
      inputs[0].focus();
    }
  },
  async mounted() {
    this.prepareSelectOptions();
    // this.cvalue = this.value + "";
    this.ready = true;
  }
};
</script >

<style >

.largefit .el-input__inner {
  height: auto !important;
  line-height: 42px !important;
}

.largefit .el-input--suffix .el-input__inner {
  padding-right: auto !important;
}
</style >
